<span [style.font-weight]="fontWeight" [style.color]="color" [innerHTML]="content"></span>
@if (content.length > this.limit) {
    @if (isContentToggled) {
        <span class="read-less-text" (click)="toggleContent()" appClickStopPropagation [innerHTML]="'common.readLess' | transloco"></span>
    } @else {
        <span class="read-more-text" (click)="toggleContent()" appClickStopPropagation [innerHTML]="'common.readMore' | transloco"></span>
    }
}